"use strict";
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperInviteModel = void 0;
const V5BaseModel_1 = require("./base/V5BaseModel");
const mobx_1 = require("mobx");
const _ = require("lodash");
let DeveloperInviteModel = (() => {
    var _a;
    let _classSuper = V5BaseModel_1.V5BaseModel;
    let _instanceExtraInitializers = [];
    let _get_requestedRoles_decorators;
    let _get_appliedRoles_decorators;
    return _a = class DeveloperInviteModel extends _classSuper {
            constructor(options) {
                // Comparative resources are based off the user model
                super('user', options);
                this.client_cardinal = __runInitializers(this, _instanceExtraInitializers);
                this.client_cardinal = this.options.clients.provisionCardinalClient();
                this.client_accounts = this.options.clients.provisionAccountsV5Client();
            }
            get requestedRoles() {
                return this.model.requested_role_ids
                    .map((r) => {
                    return this.options.banks.roleBank.item(r);
                })
                    .filter((r) => !!r);
            }
            get appliedRoles() {
                return this.model.applied_role_ids
                    .map((r) => {
                    return this.options.banks.roleBank.item(r);
                })
                    .filter((r) => !!r);
            }
            async loadRoles() {
                return this.options.banks.roleBank.loadAll(_.uniq([...(this.model.applied_role_ids || []), ...(this.model.requested_role_ids || [])]));
            }
            async getParents() {
                return [await this.getOrg()];
            }
            async acceptInvite() {
                var _b;
                await this.client_accounts.acceptInvite({
                    id: this.id
                });
                return (_b = this.org) === null || _b === void 0 ? void 0 : _b.loadDeveloperInvites();
            }
            async declineInvite() {
                var _b;
                await this.client_accounts.declineInvite({
                    id: this.id
                });
                return (_b = this.org) === null || _b === void 0 ? void 0 : _b.loadDeveloperInvites();
            }
            async delete() {
                var _b;
                await this.client_accounts.destroyInvite({
                    id: this.id
                });
                return (_b = this.org) === null || _b === void 0 ? void 0 : _b.loadDeveloperInvites();
            }
            async updateRoles(roleIds) {
                var _b;
                await this.client_accounts.updateInvite({
                    id: this.id,
                    requested_role_ids: roleIds
                });
                return (_b = this.org) === null || _b === void 0 ? void 0 : _b.loadDevelopers();
            }
            get org_id() {
                return this.model.org_id;
            }
            get user_id() {
                return this.model.user_id;
            }
            get developer() {
                return this.options.banks.developerBank.item(this.user_id);
            }
            getDeveloper() {
                return this.options.banks.developerBank.resolve(this.user_id);
            }
            get org() {
                return this.options.banks.orgBank.org(this.options.model.org_id);
            }
            getOrg() {
                return this.options.banks.orgBank.resolve(this.options.model.org_id);
            }
            /**
             * The developer and org models are not available until the
             * invited user accepts the invite. This can fallback on stored values.
             */
            get email() {
                var _b, _c;
                return (_c = (_b = this.developer) === null || _b === void 0 ? void 0 : _b.model.email) !== null && _c !== void 0 ? _c : this.model.metadata.email;
            }
            get orgName() {
                var _b, _c;
                return (_c = (_b = this.org) === null || _b === void 0 ? void 0 : _b.model.label) !== null && _c !== void 0 ? _c : this.model.metadata.org_name;
            }
            firstName() {
                var _b, _c, _d, _e;
                return (_c = (_b = this.developer) === null || _b === void 0 ? void 0 : _b.firstName()) !== null && _c !== void 0 ? _c : (_e = (_d = this.model.metadata.user_name) === null || _d === void 0 ? void 0 : _d.split(' ')) === null || _e === void 0 ? void 0 : _e[0];
            }
            lastName() {
                var _b, _c, _d, _e, _f;
                return (_c = (_b = this.developer) === null || _b === void 0 ? void 0 : _b.lastName()) !== null && _c !== void 0 ? _c : (_f = (_e = (_d = this.model.metadata.user_name) === null || _d === void 0 ? void 0 : _d.split(' ')) === null || _e === void 0 ? void 0 : _e.slice(1)) === null || _f === void 0 ? void 0 : _f.join(' ');
            }
        },
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _get_requestedRoles_decorators = [mobx_1.computed];
            _get_appliedRoles_decorators = [mobx_1.computed];
            __esDecorate(_a, null, _get_requestedRoles_decorators, { kind: "getter", name: "requestedRoles", static: false, private: false, access: { has: obj => "requestedRoles" in obj, get: obj => obj.requestedRoles }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_appliedRoles_decorators, { kind: "getter", name: "appliedRoles", static: false, private: false, access: { has: obj => "appliedRoles" in obj, get: obj => obj.appliedRoles }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
exports.DeveloperInviteModel = DeveloperInviteModel;
